// Enumeration for notification card types
export enum NotificationCardType {
  warning = 'warning',
  info = 'info'
}
